import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import type { ContainerProps, State } from '../../types';

export type Response = {
	data: {
		chatOpsEntitlementEnabled: boolean;
	};
};

export const fetchChatopsEntitlementAction =
	(): Action<State, ContainerProps> =>
	async ({ setState }, { cloudId, analyticsEvent }) => {
		try {
			const response: Response = await performGetRequest(
				`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/entitlements`,
			);
			setState({
				chatOpsEntitlementEnabled: response.data.chatOpsEntitlementEnabled,
			});

			fireOperationalAnalytics(analyticsEvent, 'getChatopsEntitlement called', {
				source: 'ChatAndVideoToolsAdminPage',
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				meta: {
					id: 'getChatopsEntitlementCallFailed',
					packageName: 'jiraServicedeskIncidentManagementSettings',

					teamName: 'itops-r2d2',
				},
				error: e,
				sendToPrivacyUnsafeSplunk: true,
			});
		}
	};
